export const environment = {
    production: false,
    apiURL: "https://apidev.smemexico.com",
    basePath: '', // En desarrollo, los archivos se sirven desde la raíz
    enableLogging: true, // Mostrar logs en desarrollo,

    firebase: {
        apiKey: "AIzaSyBBnUDXFq8kmFrBMUnMieVoz2JnJ_kcAy8",
        authDomain: "smemexico-334d1.firebaseapp.com",
        databaseURL: "https://smemexico-334d1.firebaseio.com",
        projectId: "smemexico-334d1",
        storageBucket: "smemexico-334d1.appspot.com",
        messagingSenderId: "201681790752",
        appId: "1:201681790752:web:f09b0f4bfa5bc10f8a9945",
        measurementId: "G-GSVVGT3CJ0",
    },
};
